module.exports = __webpack_public_path__ + "img/Chamber_of_commerce.56464f68.jpg";